# Route: /tracking/reviews
# Reviewer's queue of entries awaiting their signature
# Permission: TrackingRecord:sign
# Feature: F53a G6 (operator daily-use essentials)

page-tracking-review-queue:
  type: Page
  archetype: list
  meta:
    title: $t.tracking.reviews.meta_title
    route: /tracking/reviews
    layout: shell
    auth: required
  data:
    reviews:
      model: TrackingRecord[]
      # F73 — F902c required filter (key must be `filter:`, not `query:`).
      filter:
        status: PendingReview
        pendingSignatureFor: me
      refresh: on_mount
      # F53a UX M-01: declare the four async data states (XP85-DS-007) so the
      # emitter renders domain-aware placeholders rather than generic text.
      # The empty node is defined at the DataTable level below.
      data_states:
        loading:
          skeleton_count: 5
        empty:
          ref: review-queue-empty
        error: default
  spatial:
    display: flex
    direction: column
    gap: $spacing.xl
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
    responsive:
      sm:
        padding: $spacing.sm
        padding_inline: $spacing.sm
        gap: $spacing.md
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - review-queue-header
    - review-queue-table

# ── Header ───────────────────────────────────────────────────────────────────

review-queue-header:
  type: PageHeader
  content: $t.tracking.reviews.title

# ── Results table ────────────────────────────────────────────────────────────

review-queue-table:
  type: DataTable
  bind:
    rows: reviews
  a11y:
    label: $t.tracking.reviews.table_label
  spatial:
    overflow: auto
  # XP87 #1400 — the queue is read a page at a time, longest-waiting first (the order is the
  # countersignature policy, NpgsqlTrackingRecordRepository.GetPendingSignatureForAsync). The
  # pager states "Showing X–Y of N" from the API's `total` and pages the server query, so a
  # backlog longer than one page never reads as the whole queue.
  pagination:
    mode: pages
  # No client quick-filter: it would narrow only the page on screen while the pager
  # states the whole queue, so an author whose entries sit on page 2 would read as
  # "Nothing to review" beside "Showing 1–50 of 109". XP85057 refuses `filter:` on a
  # paginated table; a queue filter belongs in the server query, which the
  # pending-signature read does not take today (it filters by form name only).
  columns:
    - key: timestamp
      label: $t.tracking.reviews.col_timestamp
      format: compliance-datetime
      width: 2fr
    - key: authorDisplayName
      label: $t.tracking.reviews.col_author
      width: 1fr
    - key: formName
      label: $t.tracking.reviews.col_form
      width: 1fr
    - key: contextDisplayName
      label: $t.tracking.reviews.col_context
      width: 1fr
  row_action:
    type: navigate
    route: /tracking/records/:id/sign
    params:
      id: $row.id
    # F79 — return to the review queue after sign (origin_only this pass;
    # list_state restoration is A-phase-2, no CIR change to upgrade later).
    return_context: origin_only
  empty: review-queue-empty

review-queue-empty:
  type: EmptyState
  content: $t.tracking.reviews.empty
  body: $t.tracking.reviews.empty_body
